import axios from "axios";

export async function getSpotifyData(artistname, trackname) {
    try {
        
        const config = {
            headers: {
                "Access-Control-Allow-Headers": "privatekey",
            },
        };
        const result = await axios
            .get(
                `https://us-central1-creditzmusic.cloudfunctions.net/httpsSpotifyToken-spotifyToken/searchTrackArtist?artist=${artistname}&track=${trackname}`,
                config
            )
            return result;
    } catch (error) {
        Promise.reject(error)
    }

}

